var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 16.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6562 12.9206C23.6376 12.8026 23.4483 11.7426 22.6803 10.9686C21.9089 10.214 20.8449 10.0273 20.7262 10.0086C20.5682 9.98264 20.4069 10.016 20.2716 10.1C20.2242 10.1293 19.5289 10.5646 18.1562 11.7253C18.8623 11.9746 19.7749 12.4073 20.5149 13.1313C21.2576 13.858 21.7016 14.752 21.9562 15.4453C23.1029 14.1053 23.5342 13.4266 23.5629 13.38C23.6482 13.2433 23.6816 13.08 23.6562 12.9206Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9672 12.7676C16.2519 13.4129 15.4192 14.1969 14.4659 15.1436C10.4239 19.1569 9.36392 20.7616 9.32058 20.8276C9.25992 20.9209 9.22325 21.0282 9.21458 21.1389L9.00192 23.8529C8.98725 24.0476 9.05725 24.2382 9.19525 24.3762C9.32058 24.5016 9.49058 24.5716 9.66725 24.5716C9.68392 24.5716 9.70125 24.5716 9.71858 24.5696L12.4526 24.3589C12.5626 24.3502 12.6686 24.3149 12.7612 24.2556C12.8279 24.2129 14.4432 23.1602 18.4846 19.1476C19.4592 18.1796 20.2632 17.3369 20.9212 16.6162C20.8206 16.1836 20.4692 14.9489 19.5846 14.0842C18.6872 13.2062 17.3966 12.8622 16.9672 12.7676Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.c90120cb97a889a5e0e29b5d27dc91ad.svg";
export { ForwardRef as ReactComponent };